import { Head, Link } from '@inertiajs/react'
import { Fragment } from 'react'
import Order from './Order'
import FlashMessages from '../../components/FlashMessages';

export default function Index({ orders, statuses }) {
  return (
    <>
      <Head title='Orders' />
      <div className='mx-auto max-w-6xl px-6 py-8'>
        <FlashMessages />

        <div className='mb-4'>
          <Link
            href='/products'
            className='rounded-lg py-2 px-4 text-white border border-white inline-block font-medium font-body shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
          >
            ← Back
          </Link>
        </div>

        <div className='text-center mb-10'>
          <h1 className='font-bold text-4xl text-white'>Orders</h1>
          <p className='text-gray-200 mt-2'>Manage and track customer orders</p>
        </div>

        {orders.length > 0 ? (
          <div className='grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
            {orders.map((order) => (
              <Fragment key={order.id}>
                <Order order={order} statuses={statuses} />
              </Fragment>
            ))}
          </div>
        ) : (
          <div className='text-center py-12 text-gray-500 text-lg'>
            No orders yet.
          </div>
        )}
      </div>
    </>
  );
}
